var React = require('react');

function Eye12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M105,2.1C48.1,2.1,2.1,48.1,2.1,105c0,56.9,46.1,102.9,102.9,102.9S207.9,161.9,207.9,105C207.9,48.1,161.9,2.1,105,2.1\n\tL105,2.1z M105,177.1c-39.7,0-72.1-32.3-72.1-72.1S65.3,32.9,105,32.9s72.1,32.3,72.1,72.1S144.7,177.1,105,177.1L105,177.1z\n\t M105,177.1"}));
}

Eye12.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 210 210","style":{"enableBackground":"new 0 0 210 210"},"xmlSpace":"preserve"};

module.exports = Eye12;

Eye12.default = Eye12;
